import React, { memo, useEffect, useState } from "react";
import Noimg from "../images/no_img.jpg";
import { useNavigate } from "react-router-dom";
import { currentRegister } from "utility/Constant";
import { getBranchId, getOrderStatus } from "utility/HeaderConfig";
import { getProduct } from "api/ProductApi";
import ProductCommon from "../components/ProductLike&Wish";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function ProductCard({ item, onClick }) {
  const [hov, setHov] = useState(false);
  const imgSrc = item.images === "@#@" || !item.images ? Noimg : item.images.split("@#@")?.[0];

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: "#fff", borderRadius: 14, overflow: "hidden",
        border: "1px solid #f2f2f7", cursor: "pointer",
        transform: hov ? "translateY(-4px)" : "none",
        boxShadow: hov ? "0 12px 32px rgba(0,0,0,.12)" : "0 2px 8px rgba(0,0,0,.05)",
        transition: "transform .24s, box-shadow .24s",
        position: "relative",
        /* Fixed dimensions so single card = same size as multi */
        width: "100%",
      }}
    >
      <div style={{ position: "absolute", top: 8, right: 8, zIndex: 2 }} onClick={(e) => e.stopPropagation()}>
        <ProductCommon categoryItem={item} />
      </div>
      {item.stockStatus === "Sale" ? (
        <span className="bsc-badge">
          Available
        </span>
      ) : <span className="pl-card-soldbadge">
          Sold
        </span>}
      <div style={{ overflow: "hidden", background: "#fafafa", aspectRatio: "1" }}>
        <img
          src={imgSrc}
          alt={item.title || "Product"}
          loading="lazy"
          style={{
            width: "100%", height: "100%", objectFit: "cover",
            transform: hov ? "scale(1.06)" : "scale(1)",
            transition: "transform .5s cubic-bezier(.16,1,.3,1)",
          }}
        />
      </div>
      <div style={{ padding: "12px 14px" }}>
        <p style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: ".08em", textTransform: "uppercase", color: "#98989d", margin: "0 0 3px" }}>
          {item.metalType}
        </p>
        <p style={{ fontSize: 13, fontWeight: 500, color: "#ae60f8", margin: "0 0 8px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "capitalize" }} title={item.title}>
          {item.title}
        </p>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#4f3267", fontFamily: "var(--font-body, Georgia,serif)" }}>
            ₹{Math.trunc(item.total).toLocaleString("en-IN")}
          </span>
          {item.goldPurity && item.goldPurity !== "-" && (
            <span style={{ fontSize: 10.5, color: "#98989d" }}>{item.goldPurity}</span>
          )}
        </div>
      </div>
    </div>
  );
}

function RelatedProduct({ Details }) {
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentId, setCurrentId] = useState(null);
  const [scrollPos, setScrollPos] = useState(0);
  const sliderRef = React.useRef(null);
  const history = useNavigate();

  useEffect(() => {
    if (Details?.length !== 0) {
      setCurrentId(Details.id || Details.productId || null);
      getProductList();
    }
    //eslint-disable-next-line
  }, [Details]);

  const getProductList = () => {
    const filterData = {
      removeNTP: "NTP-", removeHP: "HP-",
      beforeCreatedAt: currentRegister(),
      branch: getBranchId(),
      ...(Details.productTypeId && { metaProdTypeEnty: Details.productTypeId }),
      ...(Details.categoryId && { metaProdCateEnty: Details.categoryId }),
      statusId: getOrderStatus(),
      allowCatalogue: 1,
      productDemoStatus: "Available_For_Demo,Demo_Completed,Demo_Cancelled",
    };
    getProduct(50, filterData)
      .then((data) => {
        let products;
      if (data.response && typeof data.response === "string") {
        try {
          const sanitizedResponse = data.response.replace(/\bNaN\b/g, "null");
          products = JSON.parse(sanitizedResponse);
        } catch (parseError) {
          console.error("Failed to parse response:", parseError);
          products = { content: [], totalCount: 0 };
        }
      } else {
        products = data.response || { content: [], totalCount: 0 };
      }
        setCategoryList(products.content);
        setLoading(false);
      })
      .catch(console.log);
  };

  const filteredList = categoryList?.filter((item) => {
    const itemId = item.id || item.productId;
    return String(itemId) !== String(currentId);
  });

  if (!loading && filteredList?.length === 0) return null;

  const CARD_W = 240;
  const GAP = 16;

  const scrollBy = (dir) => {
    const el = sliderRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (CARD_W + GAP) * 2, behavior: "smooth" });
  };

  const handleScroll = () => {
    if (sliderRef.current) setScrollPos(sliderRef.current.scrollLeft);
  };

  const canScrollLeft = scrollPos > 0;
  const canScrollRight = sliderRef.current
    ? scrollPos < sliderRef.current.scrollWidth - sliderRef.current.clientWidth - 4
    : true;

  return (
    <section style={{ padding: "56px 0", background: "#f9f3f9" }}>
      <div className="container">
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 28 }}>
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".16em", textTransform: "uppercase", color: "#f356d1ef", margin: "0 0 6px" }}>
              You may also like
            </p>
            <h2 style={{ fontFamily: "Cormorant Garamond,Georgia,serif", fontSize: "clamp(24px,3vw,34px)", fontWeight: 500, color: "#4f3267", margin: 0 }}>
              Similar Products
            </h2>
          </div>
          {!loading && (
            <div style={{ display: "flex", gap: 8 }}>
              <button
                onClick={() => scrollBy(-1)}
                disabled={!canScrollLeft}
                style={{
                  width: 38, height: 38, borderRadius: "50%",
                  border: "1.5px solid #d9c8e8",
                  background: canScrollLeft ? "#4f3267" : "#f2f2f7",
                  color: canScrollLeft ? "#fff" : "#b0a0c0",
                  cursor: canScrollLeft ? "pointer" : "not-allowed",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  transition: "all .2s",
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
              </button>
              <button
                onClick={() => scrollBy(1)}
                disabled={!canScrollRight}
                style={{
                  width: 38, height: 38, borderRadius: "50%",
                  border: "1.5px solid #d9c8e8",
                  background: canScrollRight ? "#4f3267" : "#f2f2f7",
                  color: canScrollRight ? "#fff" : "#b0a0c0",
                  cursor: canScrollRight ? "pointer" : "not-allowed",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  transition: "all .2s",
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="9 18 15 12 9 6"/></svg>
              </button>
            </div>
          )}
        </div>

        {loading ? (
          <div style={{ display: "flex", gap: GAP, overflow: "hidden" }}>
            {[1, 2, 3, 4].map((i) => (
              <div key={i} style={{ minWidth: CARD_W, borderRadius: 14, overflow: "hidden", flexShrink: 0 }}>
                <Skeleton style={{ height: 200 }} />
                <div style={{ padding: 14 }}>
                  <Skeleton height={12} style={{ marginBottom: 6, borderRadius: 4 }} />
                  <Skeleton height={14} style={{ marginBottom: 8, borderRadius: 4 }} />
                  <Skeleton height={18} width="40%" style={{ borderRadius: 4 }} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            ref={sliderRef}
            onScroll={handleScroll}
            style={{
              display: "flex",
              gap: GAP,
              overflowX: "auto",
              scrollSnapType: "x mandatory",
              WebkitOverflowScrolling: "touch",
              paddingBottom: 8,
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {filteredList?.map((item, i) => (
              <div
                key={item.id || i}
                style={{ minWidth: CARD_W, maxWidth: CARD_W, flexShrink: 0, scrollSnapAlign: "start" }}
              >
                <ProductCard
                  item={item}
                  onClick={() => history(`/ProductDetails/${item.id}`, { state: { categoryItem: item } })}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <style>{`
        div[style*="overflowX: auto"]::-webkit-scrollbar { display: none; }
      `}</style>
    </section>
  );
}

export default memo(RelatedProduct);